module.exports = __webpack_public_path__ + "img/handraw_paiement orange.453e4316.svg";